import { z } from "zod";

export interface CounterDeliveryEntity {
  id: 1761;
  fechaCreacion: string;
  titular: string;
  monto: number;
  precioFinal: number
  toneladas: number;
  estadoDescripcion: string;
  grano: string;
  sinBase: boolean;
}

export interface CounterDeliveryHarvest {
  cosecha: string;
}

export interface CounterDeliveryListResponse {
  listado: CounterDeliveryEntity[];
  totalPages: number;
  totalRecords: number;
  pendingRequests: boolean;
}

export interface CounterDeliveryDetail {
  id: number;
  montoSolicitado: number;
  saldoActual: number;
  control: boolean;
  fechaSolicitud: string;
  cuentaOrigen: number;
  sucursal: string;
  solicitante: string;
  estado: string;
  mensajes: Array<{
    esUsted: boolean;
    texto: string;
    fechaHora: string;
    usuario: string;
  }>;
  titular: string;
  esCanje: boolean;
  grano: string;
  cosecha: string;
  toneladas: number;
  precioFinal?: number
  sinBase: boolean;
}

export const counterDeliverySchema = z.object({
  account: z.any().optional(),
  grain: z.any().optional(),
  harvest: z.any().optional(),
  ton: z.any().optional(),
  price: z.any().optional(),
  isExchange: z.boolean().optional().nullish(),
  delivery_detail: z.any().optional(),
  available_ton: z.any().optional(),
});
